// src/models/message.ts
import {useState} from 'react';
import {toAudit} from '@/components/Biz/IYB_OA/service';

export default function useMessageModel() {
  const [messageCount, setMessageCount] = useState<number>(0);

  // 定义更新方法
  const incrementMessageCount = (count: number) => {
    setMessageCount((prev) => prev + count);
  };

  const minusMessageCount = (count: number) => {
    setMessageCount((prev) => prev - count);
  };

  const initMessageCount = async () => {
    let resForToAudit = await toAudit({size: 5000, queryData: {}});
    setMessageCount(resForToAudit?.content?.length || 0);
  }

  return {
    messageCount,
    incrementMessageCount,
    minusMessageCount,
    initMessageCount
  };
}
